import { ThemeProvider } from './ThemeProvider';
export {
  withTheme,
  ThemeContext,
  ThemeProvider,
  useTheme
} from './ThemeProvider';
export default ThemeProvider;
